import {
  ApprovalSource,
  ApprovalSourceType,
  ApprovalType,
  IAllowedApproval,
  IRequestedApproval,
  ISupervisor,
} from "amnPos/ticket/Ticket";
import ApprovalsApi from "./ApprovalsApi";
import { useDispatch } from "react-redux";
import { addApproval } from "amnPos/ticket/TicketSlice";
import MessageDialogContext from "context/MessageDialogContext";
import { useContext } from "react";
import useTranslate from "hooks/useTranslate";
import { MessageDialogType } from "constants/messageDialogType";
import { useAppSelector } from "app/hooks";
import { NIL } from "uuid";
import {
  IClient,
  IMenusOptions,
  IOrder,
  IPreaparingAndServing,
  IReportsOptions,
  IShift,
  ITransactionPermissions,
  ITransactions,
} from "adminPanel/employee/models/IEmployee";
import { IAskSupervisorApproval } from "./IApprovals";
import { posSettingSlice } from "amnPos/slices/PosSettingSlice";
import { POSType } from "amnPos/pages/UserHomePage";
import { addApproval as addApprovalRest } from "amnRestaurants/ticket/restTicketSlice";
import {
  addClientsApprovals,
  addExternalOperationsApprovals,
  addStandAloneTicketsApprovals,
  addTicketApprovals,
} from "slices/Approvals/ApprovalSlice";
import { useLocation, useParams } from "react-router";
import {
  MappClientCommandToApprovalSourceType as MappCommandToApprovalSourceType,
  MappTicketTypeToApprovalSourceType,
} from "./approvalHelper";
import { OrderType } from "models/common-props/TransactionTypes";

export default function useApproval() {
  const dispatch = useDispatch();
  const messageDialog = useContext(MessageDialogContext);
  const { translate } = useTranslate("pos.message.error");
  const employeeSettings = useAppSelector((store) => store.employeeSettings);
  const posSettings = useAppSelector((store) => store.posSetting);
  const shiftInfo = useAppSelector((store) => store.shiftInfo);
  const posType = localStorage.getItem("posType");
  const posTypeEnum: POSType | undefined =
    Number(posType) in POSType ? (Number(posType) as POSType) : undefined;
  const ticket = useAppSelector((s) =>
    posTypeEnum === POSType.Restaurants ? s.restTicket : s.ticket,
  );
  const defaultCurrency = posSettings.currencies?.find((c) => c.isDefault);

  const location = useLocation();
  const params = useParams();
  async function CreateSupervisorItemDiscountApproval(
    requestedApproval: IRequestedApproval,
  ): Promise<IAllowedApproval[] | null> {
    if (!posSettings.isPosHasSupervisors) {
      return null;
    }
    await ApprovalsApi.CreateSupervisorItemDiscountApproval(requestedApproval)
      .then((result) => {
        dispatch(addApproval(result.data));
        return result.data;
      })
      .catch((e) => {
        return null;
      });

    return null;
  }
  //later on some maybe no need to save in redux as it will be completed once created
  async function CreateSupervisorExternalTransaction(
    requestedApproval: IRequestedApproval,
    supervisorTransactionsOptions: ITransactions,
  ): Promise<IAllowedApproval[] | null> {
    if (!posSettings.isPosHasSupervisors) {
      return null;
    }
    if (
      requestedApproval.type === ApprovalType.SupervisorPayToClient &&
      !supervisorTransactionsOptions.canPayToClient
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorReciveFromClient &&
      !supervisorTransactionsOptions.canReciveFromClient
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorPayToCenteralBox &&
      !supervisorTransactionsOptions.canPayToCenteralBox
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorReciveFromCenteralBox &&
      !supervisorTransactionsOptions.canReciveFromCenteralBox
    )
      return null;
    if (
      requestedApproval.type ===
        ApprovalType.SupervisorDeleteExternalTransaction &&
      !supervisorTransactionsOptions.canDeleteExternalTransacation
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorMaxAllowedTransaction &&
      supervisorTransactionsOptions.isHavingMaxValueForTransaction
    ) {
      if (
        supervisorTransactionsOptions.maxAllowedValueTransaction <
        (requestedApproval?.valueAllowed ?? 0)
      )
        return null;
    }

    try {
      const result = await ApprovalsApi.CreateSupervisorExternalTransaction(
        requestedApproval,
      );
      return result.data;
    } catch (e) {
      return null;
    }
  }
  function SaveApproval(approvals: IAllowedApproval[]) {
    //later on some maybe no need to save in redux as it will be completed once created
    approvals.forEach((approval) => {
      switch (approval.type) {
        case ApprovalType.SupervisorPayToClient:
        case ApprovalType.SupervisorReciveFromClient:
        case ApprovalType.SupervisorPayToCenteralBox:
        case ApprovalType.SupervisorReciveFromCenteralBox:
        //case ApprovalType.SupervisorDeleteExternalTransaction:
        case ApprovalType.SupervisorMaxAllowedTransaction:
          dispatch(addExternalOperationsApprovals([approval]));
          break;
        case ApprovalType.SupervisorChangeItemPrice:
        case ApprovalType.SupervisorSellWithDept:
        case ApprovalType.SupervisorRemoveItem:
        case ApprovalType.SupervisorDecreaseItemQuantity:
        case ApprovalType.SupervisorItemDiscount:
        case ApprovalType.SupervisorAllItemDiscount:
        case ApprovalType.SupervisorUseForignCurrencies:
        case ApprovalType.SupervisorReceivePrepayment:
        case ApprovalType.SupervisorEditSavedOrder:
        //case ApprovalType.SupervisorAddDeliveryOrder:
        case ApprovalType.SupervisorEditDeliveryFees:
        //case ApprovalType.SupervisorAddPickUpOrder:
        case ApprovalType.SupervisorChangeExchgangeRate:
        case ApprovalType.SupervisorSettleTableOrder:
        case ApprovalType.SupervisorCancelOrder:
        case ApprovalType.SupervisorSettlePickupOrder:
        case ApprovalType.SupervisorMoveOrder:
        case ApprovalType.SupervisorMoveOrderItems:
        case ApprovalType.SupervisorPrintCustomizationBeforeCollect:
        case ApprovalType.SupervisorSendEReceipt:
          if (params?.id) {
            dispatch(addStandAloneTicketsApprovals([approval]));
          } else {
            if (location.pathname.includes("/shiftsAndExternals")) {
              dispatch(addExternalOperationsApprovals([approval]));
            } else {
              //dispatch(addTicketApprovals([approval]));
              if (posTypeEnum === POSType.POS) {
                dispatch(addApproval([approval]));
              } else {
                dispatch(addApprovalRest([approval]));
              }
            }
          }
          break;
        case ApprovalType.SupervisorAddNewClient:
        case ApprovalType.SupervisorModifyExistingClient:
        case ApprovalType.SupervisorChangeDefaultCountryAndProvince:
        case ApprovalType.SupervisorAddNewAddress:
        case ApprovalType.SupervisorModifyAddress:
          dispatch(addClientsApprovals([approval]));
          break;
      }
    });
  }
  async function CreateSupervisorTransactionPermission(
    requestedApproval: IRequestedApproval,
    supervisorTransactionsPermissionOptions: ITransactionPermissions,
    supervisorOrderOptions: IOrder,
  ): Promise<IAllowedApproval[] | null> {
    if (!posSettings.isPosHasSupervisors) {
      return null;
    }
    if (
      requestedApproval.type === ApprovalType.SupervisorChangeItemPrice &&
      !supervisorTransactionsPermissionOptions.changePrice
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorSellWithDept &&
      !supervisorTransactionsPermissionOptions.sellInDebt
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorUseForignCurrencies &&
      !supervisorTransactionsPermissionOptions.canUseFc
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorRemoveItem &&
      !supervisorTransactionsPermissionOptions.deleteAnItem
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorDecreaseItemQuantity &&
      !supervisorTransactionsPermissionOptions.reduceQuantity
    )
      return null;
    if (
      requestedApproval.type ===
        ApprovalType.SupervisorShowSettledTransaction &&
      !supervisorTransactionsPermissionOptions.viewSettledTransactions
    )
      //iam guessing that should be on shift level and open every time normally during shift and be completed once created
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorManuallyOpenDrawer &&
      !supervisorTransactionsPermissionOptions.openDrawerManualy
    )
      //iam guessing that should be on shift level and open every time normally during shift and be completed once created
      return null;
    if (
      requestedApproval.type ===
        ApprovalType.SupervisorRepeatPrintingSettledTransaction &&
      !supervisorTransactionsPermissionOptions.reprintSettledTransaction
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorChangeExchgangeRate &&
      !supervisorTransactionsPermissionOptions.canModifyExChangeRates
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorPrintCustomizationBeforeCollect &&
      !supervisorTransactionsPermissionOptions.printCustomizationBeforeCollect
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorSendEReceipt &&
      !supervisorTransactionsPermissionOptions.sendEReceipt
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorEditSavedOrder &&
      !supervisorOrderOptions.editSavedOrder
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorCancelOrder &&
      !supervisorOrderOptions.cancelOrder
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorAddDeliveryOrder &&
      !supervisorOrderOptions.addDeliveryOrder
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorAddPickUpOrder &&
      !supervisorOrderOptions.addPickUpOrder
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorHandleTableOrder &&
      !supervisorOrderOptions.canHandleTableOrder
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorSettlePickupOrder &&
      !supervisorOrderOptions.settlePickupOrder
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorSettleTableOrder &&
      !supervisorOrderOptions.settleTableOrder
    )
      return null;

    try {
      const result =
        await ApprovalsApi.CreateSupervisorInstantCompletedApproval(
          requestedApproval,
        );
      return result.data;
    } catch (e) {
      return null;
    }
  }
  async function CreateSupervisorShiftPermission(
    requestedApproval: IRequestedApproval,
    supervisorShiftOptions: IShift,
  ): Promise<IAllowedApproval[] | null> {
    if (!posSettings.isPosHasSupervisors) {
      return null;
    }
    if (
      requestedApproval.type === ApprovalType.SupervisorCloseShift &&
      !supervisorShiftOptions.closeShift
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorUnCloseShift &&
      !supervisorShiftOptions.unCloseShift
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorPostCashToNextShift &&
      !supervisorShiftOptions.postCashToNextShift
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorViewCalculatedCash &&
      !supervisorShiftOptions.viewCalculatedCash
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorPrintShiftSummary &&
      !supervisorShiftOptions.printShiftSummary
    )
      return null;
    if (
      requestedApproval.type ===
        ApprovalType.SupervisorChangeCentralBoxReceiptNumberMandatory &&
      supervisorShiftOptions.centralBoxReceiptNumberMandatory
    )
      return null;
    try {
      const result = await ApprovalsApi.CreateSupervisorExternalTransaction(
        requestedApproval,
      );
      return result.data;
    } catch (e) {
      return null;
    }
  }
  async function CreateSupervisorReportsPermission(
    requestedApproval: IRequestedApproval,
    supervisorReportsOptions: IReportsOptions,
  ): Promise<IAllowedApproval[] | null> {
    if (!posSettings.isPosHasSupervisors) {
      return null;
    }
    if (
      requestedApproval.type === ApprovalType.SupervisorViewShiftDigest &&
      !supervisorReportsOptions.shiftDigest
    )
      return null;
    if (
      requestedApproval.type ===
        ApprovalType.SupervisorViewCalculatedCashDetails &&
      !supervisorReportsOptions.calculatedCashDetails
    )
      return null;
    if (
      requestedApproval.type ===
        ApprovalType.SupervisorViewCalculatedNonCashDetails &&
      !supervisorReportsOptions.calculatedNonCashDetails
    )
      return null;
    if (
      requestedApproval.type ===
        ApprovalType.SupervisorViewMaterialsAndServicesTransactionsDetail &&
      !supervisorReportsOptions.materialsAndServicesTransactionsDetail
    )
      return null;
    if (
      requestedApproval.type ===
        ApprovalType.SupervisorViewExternalTransactionsDetails &&
      !supervisorReportsOptions.externalTransactionsDetails
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorViewClosingDetails &&
      !supervisorReportsOptions.closingDetails
    )
      return null;
    if (
      requestedApproval.type ===
        ApprovalType.SupervisorViewCustomerBalanceStatement &&
      !supervisorReportsOptions.customerBalanceStatement
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorShowCustomerBalance &&
      !supervisorReportsOptions.showCustomerBalance
    )
      return null;

    try {
      const result = await ApprovalsApi.CreateSupervisorExternalTransaction(
        requestedApproval,
      );
      return result.data;
    } catch (e) {
      return null;
    }
  }
  async function CreateSupervisorOrderPermission(
    requestedApproval: IRequestedApproval,
    supervisorOrderOptions: IOrder,
  ): Promise<IAllowedApproval[] | null> {
    if (!posSettings.isPosHasSupervisors) {
      return null;
    }
    if (
      requestedApproval.type === ApprovalType.SupervisorReceivePrepayment &&
      !supervisorOrderOptions.receivePrepayment
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorAddPickUpOrder &&
      !supervisorOrderOptions.addPickUpOrder
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorHandleTableOrder &&
      !supervisorOrderOptions.canHandleTableOrder
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorEditDeliveryFees &&
      !supervisorOrderOptions.editDeliveryFees
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorCancelOrder &&
      !supervisorOrderOptions.cancelOrder
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorEditSavedOrder &&
      !supervisorOrderOptions.editSavedOrder
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorUseOrderManagementTab &&
      !supervisorOrderOptions.useOrderManagementTab
    )
      return null;
    if (
      requestedApproval.type ===
        ApprovalType.SupervisorUseDeliveryOrdersManagement &&
      !supervisorOrderOptions.useDeliveryOrdersManagement
    )
      return null;

    if (
      requestedApproval.type === ApprovalType.SupervisorSettleDeliveryTrip &&
      !supervisorOrderOptions.settleDeliveryTrip
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorSettleTableOrder &&
      !supervisorOrderOptions.settleTableOrder
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorReceivePrepayment &&
      !supervisorOrderOptions.receivePrepayment
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorMoveOrder &&
      !supervisorOrderOptions.moveOrder
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorMoveOrderItems &&
      !supervisorOrderOptions.moveOrderItems
    )
      return null;
    try {
      const result = await ApprovalsApi.CreateSupervisorExternalTransaction(
        requestedApproval,
      );
      return result.data;
    } catch (e) {
      return null;
    }
  }
  async function CreateSupervisorClientPermission(
    requestedApproval: IRequestedApproval,
    supervisorClientOptions: IClient,
  ): Promise<IAllowedApproval[] | null> {
    if (!posSettings.isPosHasSupervisors) {
      return null;
    }

    if (
      requestedApproval.type === ApprovalType.SupervisorAddNewClient &&
      !supervisorClientOptions.canAddNewClient
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorModifyExistingClient &&
      !supervisorClientOptions.canModifyExistingClient
    )
      return null;
    if (
      requestedApproval.type ===
        ApprovalType.SupervisorChangeDefaultCountryAndProvince &&
      !supervisorClientOptions.canChangeDefaultCountryAndProvince
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorAddNewAddress &&
      !supervisorClientOptions.canAddNewAddress
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorModifyAddress &&
      !supervisorClientOptions.canModifyAddress
    )
      return null;

    try {
      const result = await ApprovalsApi.CreateSupervisorExternalTransaction(
        requestedApproval,
      );
      return result.data;
    } catch (e) {
      return null;
    }
  }

  async function CreateSupervisorMenusPermission(
    requestedApproval: IRequestedApproval,
    supervisorMenusOptions: IMenusOptions,
  ): Promise<IAllowedApproval[] | null> {
    if (!posSettings.isPosHasSupervisors) {
      return null;
    }

    if (
      requestedApproval.type === ApprovalType.SupervisorChangeMenu &&
      !supervisorMenusOptions.canChangeMenu
    )
      return null;
    if (
      requestedApproval.type ===
        ApprovalType.SupervisorChangeMenuWhenOpenOrder &&
      !supervisorMenusOptions.canChangeMenuWhenOpenOrder
    )
      return null;

    try {
      const result = await ApprovalsApi.CreateSupervisorExternalTransaction(
        requestedApproval,
      );
      return result.data;
    } catch (e) {
      return null;
    }
  }

  async function CreateSupervisorPreparingAndServingPermission(
    requestedApproval: IRequestedApproval,
    supervisorPreparingAndServing: IPreaparingAndServing,
  ): Promise<IAllowedApproval[] | null> {
    if (!posSettings.isPosHasSupervisors) {
      return null;
    }

    if (
      requestedApproval.type ===
        ApprovalType.SupervisorCancelOrderAfterPreparationStarts &&
      !supervisorPreparingAndServing.canCancelOrderAfterPreparationStarts
    )
      return null;
    if (
      requestedApproval.type ===
        ApprovalType.SupervisorCancelOrderAfterServed &&
      !supervisorPreparingAndServing.canCancelOrderAfterServed
    )
      return null;
    if (
      requestedApproval.type ===
        ApprovalType.SupervisorCancelItemAfterPreparationStarts &&
      !supervisorPreparingAndServing.canCancelItemAfterPreparationStarts
    )
      return null;
    if (
      requestedApproval.type === ApprovalType.SupervisorCancelItemAfterServed &&
      !supervisorPreparingAndServing.canCancelItemAfterServed
    )
      return null;
    if (
      requestedApproval.type ===
        ApprovalType.SupervisorChangeItemQuantityAfterPreparationStarts &&
      !supervisorPreparingAndServing.canChangeItemQuantityAfterPreparationStarts
    )
      return null;
    if (
      requestedApproval.type ===
        ApprovalType.SupervisorChangeItemQuantityAfterServed &&
      !supervisorPreparingAndServing.canChangeItemQuantityAfterServed
    )
      return null;
    if (
      requestedApproval.type ===
        ApprovalType.SupervisorReturnOrderFromInPreparation &&
      !supervisorPreparingAndServing.canReturnOrderFromInPreparation
    )
      return null;
    if (
      requestedApproval.type ===
        ApprovalType.SupervisorEndPreparationInKitchenWindow &&
      !supervisorPreparingAndServing.canEndPreparationInKitchenWindow
    )
      return null;

    try {
      const result = await ApprovalsApi.CreateSupervisorExternalTransaction(
        requestedApproval,
      );
      return result.data;
    } catch (e) {
      return null;
    }
  }

  function AskSupervisorApproval(
    approvalType: ApprovalType,
    onSuccess: (approval: IAllowedApproval[]) => void,
    onFailure: () => void,
    additionalInfo: IAskSupervisorApproval,
  ) {
    const supervisorApprovalTitleDialogMessage =
      translate("supervisorApproval");
    const actionIsNotAllowedTitleDialogMessage =
      translate("actionIsNotAllowed");
    const enterSupervisorPinCodeBodyMessage = translate(
      "pleaseEnterSupervisorPinCode",
    );
    const youDontHaveNeededPermissions = translate(
      "youDontHaveNeededPermissions",
    );
    if (!posSettings.isPosHasSupervisors) {
      messageDialog.setErrorMessageInfo(
        actionIsNotAllowedTitleDialogMessage,
        youDontHaveNeededPermissions,
      );
      onFailure();
      return;
    }
    let onOk: (info: any) => Promise<IAllowedApproval[] | null>;

    try {
      switch (approvalType) {
        case ApprovalType.SupervisorAllItemDiscount:
        case ApprovalType.SupervisorItemDiscount:
          onOk = async (info: any) =>
            await CreateSupervisorItemDiscountApproval({
              employeeId: employeeSettings.id ?? NIL,
              supervisorId: info?.id ?? NIL,
              pin: info?.pinCode ?? "",
              type: approvalType,
              valueAllowed: 0,
              items: additionalInfo.items,
              discountPercentageAllowed:
                additionalInfo.discountPercentageAllowed,
              shiftId: shiftInfo.id,
              posId: posSettings.id,
              source: ApprovalSource.MaterialsOperations,
              sourceType: MappTicketTypeToApprovalSourceType(ticket.orderType),
              currencyId: defaultCurrency?.id,
            });
          break;
        case ApprovalType.SupervisorPayToClient:
        case ApprovalType.SupervisorReciveFromClient:
        case ApprovalType.SupervisorPayToCenteralBox:
        case ApprovalType.SupervisorReciveFromCenteralBox:
        case ApprovalType.SupervisorDeleteExternalTransaction:
        case ApprovalType.SupervisorMaxAllowedTransaction:
          onOk = async (info: any) =>
            await CreateSupervisorExternalTransaction(
              {
                employeeId: employeeSettings.id ?? NIL,
                supervisorId: info?.id ?? NIL,
                pin: info?.pinCode ?? "",
                type: approvalType,
                valueAllowed: additionalInfo.allowedValue,
                items: additionalInfo.items,
                discountPercentageAllowed:
                  additionalInfo.discountPercentageAllowed,
                shiftId: shiftInfo.id,
                posId: posSettings.id,
                clientId: additionalInfo.clientId,
                source: ApprovalSource.ExternalOperations,
                sourceType:
                  additionalInfo.sourceType ??
                  MappCommandToApprovalSourceType(approvalType),
                currencyId: defaultCurrency?.id,
              },
              info.supervisorTransactionsOptions,
            );
          break;
        case ApprovalType.SupervisorEditSavedOrder:
        case ApprovalType.SupervisorCancelOrder:
          onOk = async (info: any) =>
            await CreateSupervisorTransactionPermission(
              {
                employeeId: employeeSettings.id ?? NIL,
                supervisorId: info?.id ?? NIL,
                pin: info?.pinCode ?? "",
                type: approvalType,
                valueAllowed: additionalInfo.allowedValue,
                items: additionalInfo.items,
                discountPercentageAllowed:
                  additionalInfo.discountPercentageAllowed,
                ticketIds: additionalInfo.ticketIds,
                shiftId: shiftInfo.id,
                posId: posSettings.id,
                source: ApprovalSource.Commands,
                sourceType: MappCommandToApprovalSourceType(approvalType),
                currencyId: defaultCurrency?.id,
              },
              info.supervisorTransactionsPermissionOptions,
              info.supervisorOrderOptions,
            );
          break;
        case ApprovalType.SupervisorSettlePickupOrder:
          onOk = async (info: any) =>
            await CreateSupervisorTransactionPermission(
              {
                employeeId: employeeSettings.id ?? NIL,
                supervisorId: info?.id ?? NIL,
                pin: info?.pinCode ?? "",
                type: approvalType,
                valueAllowed: additionalInfo.allowedValue,
                items: additionalInfo.items,
                discountPercentageAllowed:
                  additionalInfo.discountPercentageAllowed,
                ticketIds: additionalInfo.ticketIds,
                shiftId: shiftInfo.id,
                posId: posSettings.id,
                source: ApprovalSource.Commands,
                sourceType: MappCommandToApprovalSourceType(approvalType),
                currencyId: defaultCurrency?.id,
              },
              info.supervisorTransactionsPermissionOptions,
              info.supervisorOrderOptions,
            );
          break;
        case ApprovalType.SupervisorItemDiscount:
        case ApprovalType.SupervisorAllItemDiscount:
        // case ApprovalType.SupervisorReceivePrepayment:
        case ApprovalType.SupervisorAddDeliveryOrder:
        case ApprovalType.SupervisorEditDeliveryFees:
        case ApprovalType.SupervisorAddPickUpOrder:
        case ApprovalType.SupervisorHandleTableOrder:
        case ApprovalType.SupervisorChangeItemPrice:
        case ApprovalType.SupervisorSellWithDept:
        case ApprovalType.SupervisorUseForignCurrencies:
        case ApprovalType.SupervisorRemoveItem:
        case ApprovalType.SupervisorChangeExchgangeRate:
        case ApprovalType.SupervisorDecreaseItemQuantity:
        case ApprovalType.SupervisorPrintCustomizationBeforeCollect:
        case ApprovalType.SupervisorSendEReceipt:
          const ticketId =
            additionalInfo.ticketIds?.[0] ??
            params.id ??
            (ticket.id === NIL ? undefined : ticket.id);
          const ticketIds = ticketId ? [ticketId] : [];

          onOk = async (info: any) =>
            await CreateSupervisorTransactionPermission(
              {
                employeeId: employeeSettings.id ?? NIL,
                supervisorId: info?.id ?? NIL,
                pin: info?.pinCode ?? "",
                type: approvalType,
                valueAllowed: additionalInfo.allowedValue,
                items: additionalInfo.items,
                discountPercentageAllowed:
                  additionalInfo.discountPercentageAllowed,
                ticketIds,
                shiftId: shiftInfo.id,
                posId: posSettings.id,
                source:
                  approvalType === ApprovalType.SupervisorRemoveItem ||
                  approvalType === ApprovalType.SupervisorDecreaseItemQuantity
                    ? ApprovalSource.MaterialsOperations
                    : ApprovalSource.Commands,
                sourceType: location.pathname.includes("/shiftsAndExternals")
                  ? MappCommandToApprovalSourceType(approvalType)
                  : MappTicketTypeToApprovalSourceType(
                      additionalInfo.ticketOrderType ?? ticket.orderType,
                    ),
                currencyId: additionalInfo.currencyId ?? defaultCurrency?.id,
              },
              info.supervisorTransactionsPermissionOptions,
              info.supervisorOrderOptions,
            );
          break;
        case ApprovalType.SupervisorCloseShift:
        case ApprovalType.SupervisorUnCloseShift:
        case ApprovalType.SupervisorViewCalculatedCash:
        case ApprovalType.SupervisorPrintShiftSummary:
        case ApprovalType.SupervisorChangeCentralBoxReceiptNumberMandatory:
          onOk = async (info: any) =>
            await CreateSupervisorShiftPermission(
              {
                employeeId: employeeSettings.id ?? NIL,
                supervisorId: info?.id ?? NIL,
                pin: info?.pinCode ?? "",
                type: approvalType,
                valueAllowed: additionalInfo.allowedValue,
                items: additionalInfo.items,
                discountPercentageAllowed:
                  additionalInfo.discountPercentageAllowed,
                shiftId: shiftInfo.id,
                posId: posSettings.id,
                source: ApprovalSource.Commands,
                sourceType: MappCommandToApprovalSourceType(approvalType),
                currencyId: defaultCurrency?.id,
              },
              info.supervisorShiftOptions,
            );
          break;
        case ApprovalType.SupervisorPostCashToNextShift:
          onOk = async (info: any) =>
            await CreateSupervisorShiftPermission(
              {
                employeeId: employeeSettings.id ?? NIL,
                supervisorId: info?.id ?? NIL,
                pin: info?.pinCode ?? "",
                type: approvalType,
                valueAllowed: additionalInfo.allowedValue,
                items: additionalInfo.items,
                discountPercentageAllowed:
                  additionalInfo.discountPercentageAllowed,
                shiftId: shiftInfo.id,
                posId: posSettings.id,
                source: ApprovalSource.ExternalOperations,
                sourceType: MappCommandToApprovalSourceType(approvalType),
                currencyId: defaultCurrency?.id,
              },
              info.supervisorShiftOptions,
            );
          break;
        case ApprovalType.SupervisorViewCustomerBalanceStatement:
        case ApprovalType.SupervisorViewShiftDigest:
        case ApprovalType.SupervisorViewCalculatedCashDetails:
        case ApprovalType.SupervisorViewCalculatedNonCashDetails:
        case ApprovalType.SupervisorViewMaterialsAndServicesTransactionsDetail:
        case ApprovalType.SupervisorViewExternalTransactionsDetails:
        case ApprovalType.SupervisorViewClosingDetails:
        case ApprovalType.SupervisorShowCustomerBalance:
        case ApprovalType.SupervisorShowSettledTransaction: //later on iam guessing that should be on shift level and open every time normally during shift and be completed once created
        case ApprovalType.SupervisorManuallyOpenDrawer: //later on iam guessing that should be on shift level and open every time normally during shift and be completed once created
        case ApprovalType.SupervisorRepeatPrintingSettledTransaction: //later on iam guessing that should be on shift level and open every time normally during shift and be completed once created
          onOk = async (info: any) =>
            await CreateSupervisorReportsPermission(
              {
                employeeId: employeeSettings.id ?? NIL,
                supervisorId: info?.id ?? NIL,
                pin: info?.pinCode ?? "",
                type: approvalType,
                valueAllowed: additionalInfo.allowedValue,
                items: additionalInfo.items,
                ticketIds: additionalInfo.ticketIds,
                discountPercentageAllowed:
                  additionalInfo.discountPercentageAllowed,
                shiftId: shiftInfo.id,
                posId: posSettings.id,
                source: ApprovalSource.Commands,
                sourceType: MappCommandToApprovalSourceType(approvalType),
                currencyId: defaultCurrency?.id,
                clientId: additionalInfo?.clientId,
              },
              info.supervisorReportsOptions,
            );
          break;

        // //case ApprovalType.SupervisorEditDeliveryFees:
        // onOk = async (info: any) =>
        //   await CreateSupervisorOrderPermission(
        //     {
        //       employeeId: employeeSettings.id ?? NIL,
        //       supervisorId: info?.id ?? NIL,
        //       pin: info?.pinCode ?? "",
        //       type: approvalType,
        //       valueAllowed: additionalInfo.allowedValue,
        //       items: additionalInfo.items,
        //       ticketIds: additionalInfo.ticketIds,
        //       discountPercentageAllowed:
        //         additionalInfo.discountPercentageAllowed,
        //       shiftId: shiftInfo.id,
        //       posId: posSettings.id,
        //       source: ApprovalSource.MaterialsOperations,
        //       sourceType: additionalInfo.ticketOrderType
        //         ? MappTicketTypeToApprovalSourceType(
        //             additionalInfo.ticketOrderType,
        //           )
        //         : MappCommandToApprovalSourceType(approvalType),
        //       currencyId: defaultCurrency?.id,
        //     },
        //     info.supervisorOrderOptions,
        //   );
        // break;
        case ApprovalType.SupervisorSettleTableOrder:
        case ApprovalType.SupervisorMoveOrder:
        case ApprovalType.SupervisorMoveOrderItems:
          onOk = async (info: any) =>
            await CreateSupervisorOrderPermission(
              {
                employeeId: employeeSettings.id ?? NIL,
                supervisorId: info?.id ?? NIL,
                pin: info?.pinCode ?? "",
                type: approvalType,
                valueAllowed: additionalInfo.allowedValue,
                items: additionalInfo.items,
                ticketIds: additionalInfo.ticketIds,
                discountPercentageAllowed:
                  additionalInfo.discountPercentageAllowed,
                shiftId: shiftInfo.id,
                posId: posSettings.id,
                source: ApprovalSource.Commands,
                sourceType: MappCommandToApprovalSourceType(approvalType),
                currencyId: defaultCurrency?.id,
              },
              info.supervisorOrderOptions,
            );
          break;
        case ApprovalType.SupervisorReceivePrepayment:
          onOk = async (info: any) =>
            await CreateSupervisorOrderPermission(
              {
                employeeId: employeeSettings.id ?? NIL,
                supervisorId: info?.id ?? NIL,
                pin: info?.pinCode ?? "",
                type: approvalType,
                valueAllowed: additionalInfo.allowedValue,
                items: additionalInfo.items,
                ticketIds: additionalInfo.ticketIds,
                discountPercentageAllowed:
                  additionalInfo.discountPercentageAllowed,
                shiftId: shiftInfo.id,
                posId: posSettings.id,
                source: ApprovalSource.ExternalOperations,
                sourceType: additionalInfo.ticketOrderType
                  ? MappTicketTypeToApprovalSourceType(
                      additionalInfo.ticketOrderType,
                    )
                  : MappCommandToApprovalSourceType(approvalType),
                currencyId: defaultCurrency?.id,
              },
              info.supervisorOrderOptions,
            );
          break;
        //case ApprovalType.SupervisorAddPickUpOrder:
        //case ApprovalType.SupervisorAddDeliveryOrder:
        //case ApprovalType.SupervisorCancelOrder:
        //case ApprovalType.SupervisorEditSavedOrder:
        case ApprovalType.SupervisorUseOrderManagementTab:
        case ApprovalType.SupervisorUseDeliveryOrdersManagement:
        //case ApprovalType.SupervisorSettlePickupOrder:
        case ApprovalType.SupervisorSettleDeliveryTrip:
          //case ApprovalType.SupervisorSettleTableOrder:
          onOk = async (info: any) =>
            await CreateSupervisorOrderPermission(
              {
                employeeId: employeeSettings.id ?? NIL,
                supervisorId: info?.id ?? NIL,
                pin: info?.pinCode ?? "",
                type: approvalType,
                valueAllowed: additionalInfo.allowedValue,
                items: additionalInfo.items,
                discountPercentageAllowed:
                  additionalInfo.discountPercentageAllowed,
                shiftId: shiftInfo.id,
                posId: posSettings.id,
                source: ApprovalSource.Commands,
                sourceType: MappCommandToApprovalSourceType(approvalType),
                currencyId: defaultCurrency?.id,
              },
              info.supervisorOrderOptions,
            );
          break;
        case ApprovalType.SupervisorAddNewClient:
        case ApprovalType.SupervisorModifyExistingClient:
        case ApprovalType.SupervisorChangeDefaultCountryAndProvince:
        case ApprovalType.SupervisorAddNewAddress:
        case ApprovalType.SupervisorModifyAddress:
          onOk = async (info: any) =>
            await CreateSupervisorClientPermission(
              {
                employeeId: employeeSettings.id ?? NIL,
                supervisorId: info?.id ?? NIL,
                pin: info?.pinCode ?? "",
                type: approvalType,
                valueAllowed: additionalInfo.allowedValue,
                items: additionalInfo.items,
                discountPercentageAllowed:
                  additionalInfo.discountPercentageAllowed,
                shiftId: shiftInfo.id,
                posId: posSettings.id,
                source: ApprovalSource.Commands,
                sourceType: MappCommandToApprovalSourceType(approvalType),
                currencyId: defaultCurrency?.id,
              },
              info.supervisorClientOptions,
            );
          break;
        case ApprovalType.SupervisorChangeMenu:
        case ApprovalType.SupervisorUseMenuOutsideOperatingHours:
        case ApprovalType.SupervisorChangeMenuWhenOpenOrder:
          onOk = async (info: any) =>
            await CreateSupervisorMenusPermission(
              {
                employeeId: employeeSettings.id ?? NIL,
                supervisorId: info?.id ?? NIL,
                pin: info?.pinCode ?? "",
                type: approvalType,
                valueAllowed: additionalInfo.allowedValue,
                items: additionalInfo.items,
                discountPercentageAllowed:
                  additionalInfo.discountPercentageAllowed,
                shiftId: shiftInfo.id,
                posId: posSettings.id,
                source: ApprovalSource.Commands,
                sourceType: MappCommandToApprovalSourceType(approvalType),
                currencyId: defaultCurrency?.id,
              },
              info.supervisorMenusOptions,
            );
          break;
        case ApprovalType.SupervisorCancelOrderAfterPreparationStarts:
        case ApprovalType.SupervisorCancelOrderAfterServed:
        case ApprovalType.SupervisorCancelItemAfterPreparationStarts:
        case ApprovalType.SupervisorCancelItemAfterServed:
        case ApprovalType.SupervisorChangeItemQuantityAfterPreparationStarts:
        case ApprovalType.SupervisorChangeItemQuantityAfterServed:
        case ApprovalType.SupervisorReturnOrderFromInPreparation:
        case ApprovalType.SupervisorEndPreparationInKitchenWindow:
          onOk = async (info: any) =>
            await CreateSupervisorPreparingAndServingPermission(
              {
                employeeId: employeeSettings.id ?? NIL,
                supervisorId: info?.id ?? NIL,
                pin: info?.pinCode ?? "",
                type: approvalType,
                valueAllowed: additionalInfo.allowedValue,
                items: additionalInfo.items,
                discountPercentageAllowed:
                  additionalInfo.discountPercentageAllowed,
                shiftId: shiftInfo.id,
                posId: posSettings.id,
                source: ApprovalSource.Commands,
                sourceType: MappCommandToApprovalSourceType(approvalType),
                currencyId: defaultCurrency?.id,
              },
              info.supervisorPreparingAndServing,
            );
          break;
      }
    } catch (e) {}

    messageDialog.setMessageActionInfo(
      supervisorApprovalTitleDialogMessage,
      enterSupervisorPinCodeBodyMessage,
      translate("back"),
      translate("enter"),
      MessageDialogType.ActionMessageInfo,
      () => {
        onFailure();
      },
      async (info: any) => {
        var approval = await onOk(info);
        if (approval) {
          SaveApproval(approval);
          onSuccess(approval);
        } else {
          messageDialog.setErrorMessageInfo(
            actionIsNotAllowedTitleDialogMessage,
            youDontHaveNeededPermissions,
          );
          onFailure();
        }
      },
    );
  }

  return {
    AskSupervisorApproval,
  };
}
